import Container from 'quarks/Container';
import type { BasicProps } from 'quarks/interpolations/basic';

import Modal from 'molecules/Modal/Modal';

import Form from 'components/Form';

import type { ContentfulComponentForm } from 'graphqlTypes';
import type { FC } from 'react';

interface FormPopupProps
  extends BasicProps,
    Omit<ContentfulComponentForm, 'children' | 'contentful_id' | 'id' | 'internal' | 'node_locale'> {
  open: boolean;
  onClose: () => void;
}

const FormPopup: FC<FormPopupProps> = ({ open, onClose, __typename, ...props }) => (
  <Modal open={open} onClose={onClose} width="100%" maxWidth="770px" marginX="auto" keepMounted={true}>
    <Container
      position="relative"
      paddingY={32}
      xs={{ paddingY: 0, width: '100vw' }}
      md={{ width: '100%', paddingY: 32 }}
      {...props}
    >
      <Form {...props} closeModal={() => onClose()} />
    </Container>
  </Modal>
);

export default FormPopup;
